import axios from 'axios'

import {
  StatCard,
  StatCardThin,
  StatCardLarge,
  Wrapper,
} from "../../../components";
import React, { useState, useEffect } from "react";

import Grid from "@material-ui/core/Grid";

import { ReactComponent as HombresAdultos } from "../../../img/icons/HombresAdultos.svg";
import { ReactComponent as Animales } from "../../../img/icons/Animales.svg";
import { ReactComponent as Discapacitados } from "../../../img/icons/Discapacitados.svg";
import { ReactComponent as Total } from "../../../img/icons/Total.svg";
import { ReactComponent as MujeresAdultas } from "../../../img/icons/MujeresAdultas.svg";
import { ReactComponent as Ninos } from "../../../img/icons/Ninos.svg";
import { ReactComponent as Ninas } from "../../../img/icons/Ninas.svg";
import { ReactComponent as AdultosMayores } from "../../../img/icons/adultosMayores.svg";
import { ReactComponent as AdultasMayores } from "../../../img/icons/adultasMayores.svg";
import { ReactComponent as Extranjeros } from "../../../img/icons/extranjeros.svg";

import {COUNTRY_STATISTICS_BASE_URL, CAMPAIGN_2026} from '../../../constants';


const Home = () => {

  const APIURL = `${COUNTRY_STATISTICS_BASE_URL}${CAMPAIGN_2026}`;

  const [homeData, setHomeData] = useState(null);
  const [, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  async function getData() {
    try {
      setLoading(true);
      const homeData = await axios.get(APIURL).then((data) => {
        return data.data[0];
      });
      setHomeData(homeData);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


const {totalPeople, totalAnimals, totalDisabledPeople, totalGirls,totalMen, totalWomen, totalBoys, totalReports, totalElderWomen, totalElderMen, animalsPercent, disabledPeoplePercent, totalForeigners} = homeData || {};
const totalForeignersPercent = (100 / totalPeople) * totalForeigners || 0;
const fixedForeignersPercent = totalForeignersPercent > 0 ? totalForeignersPercent.toFixed(0) : 0;

  return (
    <Wrapper padding>
      <Grid container item spacing={3} xs={12} sm={8} md={12} lg={10} xl={8}>
        <Grid item xs={12} sm={12} md={9}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <StatCardLarge
                title={totalPeople}
                value="Total de personas evacuadas"
                icon={<Total />}
                totalTitle="Total de Reportes"
                total={totalReports}
                loading={loading}
                year={2026}
              />{" "}
            </Grid>

            <Grid item xs={12} md={6}>
              <StatCard
                title={totalElderMen}
                value="Hombres"
                secondValue="adultos mayores"
                icon={<AdultosMayores />}
                color="#6BC33C"
                loading={loading}
              />{" "}
            </Grid>

            <Grid item xs={12} md={6}>
              <StatCard
                title={totalElderWomen}
                value="Mujeres"
                secondValue="adultas mayores"
                icon={<AdultasMayores />}
                color="#6BC33C"
                loading={loading}
              />{" "}
            </Grid>

            <Grid item xs={12} md={6}>
              <StatCard
                title={totalMen}
                value="Hombres"
                secondValue="jóvenes y adultos"
                icon={<HombresAdultos />}
                color="#6BC33C"
                loading={loading}
              />{" "}
            </Grid>

            <Grid item xs={12} md={6}>
              <StatCard
                title={totalWomen}
                value="Mujeres"
                secondValue="jóvenes y adultas"
                icon={<MujeresAdultas />}
                color="#6BC33C"
                loading={loading}
              />{" "}
            </Grid>

            <Grid item xs={12} md={6}>
              <StatCard
                title={totalBoys}
                value="Niños"
                secondValue="menores de 12 años"
                icon={<Ninos />}
                color="#6BC33C"
                loading={loading}
                
              />{" "}
            </Grid>

            <Grid item xs={12} md={6}>
              <StatCard
                title={totalGirls}
                value="Niñas"
                secondValue="menores de 12 años"
                icon={<Ninas />}
                color="#6BC33C"
                loading={loading}
                
              />{" "}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <StatCardThin
                title={totalDisabledPeople}
                value="Personas con discapacidad "
                icon={<Discapacitados />}
                direction="column"
                color="#39B8CD"
                percentage={disabledPeoplePercent}
                percentageText="del total de evacuados"
                textCenter={true}
                contentShort
                loading={loading}
              />
            </Grid>
            <Grid item xs={12}>
              <StatCardThin
                title={totalForeigners}
                value="Personas extranjeras"
                icon={<Extranjeros />}
                direction="column"
                color="#C8B0E6"
                percentage={fixedForeignersPercent}
                percentageText="del total de evacuados"
                difColor={true}
                textCenter={true}
                contentShort
                loading={loading}
              />
            </Grid>
            <Grid item xs={12}>
              <StatCardThin
                title={totalAnimals}
                value="Animales"
                icon={<Animales />}
                direction="column"
                color="#F5BEC8"
                percentage={animalsPercent}
                percentageText="del total de organizaciones"
                difColor={true}
                textCenter={true}
                contentShort
                loading={loading}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default Home;
